import React from 'react'
const NotFound = () => {
    return (
        <div className="no-user-main">
            <div className="no-user-content">
                <img src={`https://woonzero.com/img/undraw_empty_xct9.svg`} alt='img' /><br/>
                <p>Görünüşe göre burada bir şey yok</p>
            </div>
           
        </div>
    )
}

export default NotFound
